import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from './icon.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [IconComponent],
  exports: [IconComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ]
})
export class IconModule { }
